<template>
  <b-card no-body>
    <b-card-header class="d-flex align-items-center justify-content-between">
      <b-card-title>Yayın Planı</b-card-title>
      <b-card-sub-title
        style="margin-top: 4px"
        class="font-small-3"
      >
        İlk 10 Kayıt
      </b-card-sub-title>
    </b-card-header>
    <b-table
      striped
      responsive
      :items="dataList"
      :fields="fields"
    >
      <template #cell(title)="data">
        <b-link :to="'/topics/view/' + data.item.id">
          <div class="font-small-3 text-body">
            {{ data.item.title }}
          </div>
          <div class="font-small-2 text-warning">
            {{ data.item.sites.company }} | {{ data.item.sites.site_name }}
          </div>
        </b-link>
      </template>
      <template #cell(scheduled)="data">
        <div>
          <b-badge
            variant="light-warning"
            class="w-100"
          >
            {{ moment(data.item.scheduled).format('DD.MM.YYYY HH:mm') }}
          </b-badge>
        </div>
      </template>
    </b-table>
  </b-card>
</template>
<script>
import {
  BCard, BCardHeader, BCardTitle, BTable, BCardSubTitle, BLink, BBadge,
} from 'bootstrap-vue'

export default {
  name: 'TablePublished',
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BTable,
    BCardSubTitle,
    BLink,
    BBadge,
  },
  props: {
    dataList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'title',
          label: 'Konu',
        },
        {
          key: 'scheduled',
          label: 'Yayın Tarihi',
          thClass: 'width-100 text-nowrap text-right',
          tdClass: 'width-100 text-nowrap text-right',
        },
      ],
    }
  },
}
</script>
